var map = {
	"./1.svg": 70,
	"./10.svg": 122,
	"./11.svg": 123,
	"./12.svg": 124,
	"./13.svg": 125,
	"./14.svg": 126,
	"./15.svg": 127,
	"./16.svg": 128,
	"./17.svg": 129,
	"./18.svg": 130,
	"./19.svg": 131,
	"./2.svg": 132,
	"./20.svg": 133,
	"./21.svg": 134,
	"./22.svg": 135,
	"./24.svg": 136,
	"./26.svg": 137,
	"./27.svg": 138,
	"./28.svg": 139,
	"./3.svg": 140,
	"./30.svg": 141,
	"./31.svg": 142,
	"./32.svg": 143,
	"./33.svg": 144,
	"./34.svg": 145,
	"./35.svg": 146,
	"./37.svg": 147,
	"./38.svg": 148,
	"./4.svg": 149,
	"./40.svg": 150,
	"./42.svg": 151,
	"./43.svg": 152,
	"./44.svg": 153,
	"./46.svg": 154,
	"./48.svg": 155,
	"./5.svg": 156,
	"./50.svg": 157,
	"./51.svg": 158,
	"./52.svg": 159,
	"./55.svg": 160,
	"./56.svg": 161,
	"./57.svg": 162,
	"./59.svg": 163,
	"./6.svg": 164,
	"./62.svg": 165,
	"./66.svg": 166,
	"./7.svg": 167,
	"./73.svg": 168,
	"./8.svg": 169,
	"./80.svg": 170,
	"./83.svg": 171,
	"./86.svg": 172,
	"./87.svg": 173,
	"./89.svg": 174,
	"./9.svg": 175,
	"./95.svg": 176,
	"./all_sports.svg": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 404;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg ^\.\/.*\.svg$
// module id = 404
// module chunks = 0